<div class="custom-alert top {{ type }} {{ className }}" *ngIf="visibility">
  <div class="custom-alert__title">
    <div class="cont">
      <span class="material-icons">
        {{
          type === 'success'
            ? 'check'
            : type === 'info'
              ? 'info'
              : type === 'warning'
                ? 'warning'
                : ''
        }}</span
      >{{ type }}
    </div>
    <button class="pa-0" *ngIf="close" (click)="closeAlert()">
      <span class="material-icons ma-0">close</span>
    </button>
  </div>
  <p class="custom-alert__body" [innerHtml]="message">{{ message }}</p>
  <div *ngIf="className === 'channel-alert'" class="text-right">
    <button class="primary-btn link pa-0 mr-6" (click)="keepAlert()">No</button>
    <button class="primary-btn continue-btn" (click)="continueAlert()">
      Continue
    </button>
  </div>
  <div *ngIf="className === 'dnc-import-alert'" class="text-right mt-2">
    <button class="primary-btn continue-btn px-5 py-1" (click)="acceptAlert()">
      Ok
    </button>
  </div>
  <div *ngIf="className === 'tenant-payment-alert'" class="text-right mt-2">
    <button class="primary-btn continue-btn" (click)="logOutUserFromAlert()">
      Sign Off
    </button>
  </div>
  <div *ngIf="className === 'tenant-payment-purchase-alert'" class="text-right">
    <button class="primary-btn continue-btn mt-2" (click)="navigateToWebsite()">
      Purchase License
    </button>
  </div>
  <div *ngIf="className === 'tenant-payment-renew-alert'" class="text-right">
    <button class="primary-btn continue-btn mt-2" (click)="navigateToWebsite()">
      Renew License
    </button>
  </div>
</div>
